import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import prettyDate from 'pretty-date'

import { Text } from '../../../Atoms/Typography'
import Button from '../../../Atoms/Button'

import theme from '../../../../styles/theme'
import { getErrorLog } from '../../../../lib/request'

const Container = styled(View)`
  flex: 1;
  background-color: ${theme.colours.white};
`

const Body = styled(View)`
  flex: 1;
  padding: ${theme.gutterUnit}px;
`

const Section = styled(View)`
  margin-top: ${theme.gutterUnit}px;
`

const TextGroup = styled(View)`
  flex-direction: row;
`

const Footer = styled(View)`
  padding: ${3 * theme.gutterUnit}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colours.black};
`

export default class Settings extends PureComponent {
  render () {
    const { onCloseErrorLog } = this.props
    return (
      <Container>
        <Body>
          <Section>
            <Text bold>Errors</Text>
            {getErrorLog().map((e, i) => {
              return (
                <TextGroup key={i}>
                  <Text bold overrides={{ marginRight: 5 }}>{prettyDate.format(e.time)}</Text>
                  <Text>{e.message}</Text>
                </TextGroup>
              )
            })}
          </Section>
        </Body>
        <Footer>
          <Button darkgrey rounded onPress={onCloseErrorLog}>
            <Text white>CANCEL</Text>
          </Button>
        </Footer>
      </Container>
    )
  }
}
